export default {
  plural: 'Правила',
  materialRules: 'Правила материалов',
  attachmentRules: 'Правила стыковки',
  socketAcceptances: 'Допуски сокетов',
  fields: {
    code: 'Код',
    meshPattern: 'Паттерн меша',
    materialPattern: 'Паттерн материала',
    hostPattern: 'Паттерн хоста',
    partPattern: 'Паттерн части',
    matchType: 'Тип совпадения',
    mateRotationDeg: 'Поворот стыковки (°)',
    mirrorOnMate: 'Зеркалить при стыковке',
    nodeId: 'ID узла',
    socketPattern: 'Паттерн сокета',
    mode: 'Режим'
  },
  matchType: {
    prefix: 'Префикс',
    exact: 'Точное'
  },
  acceptanceMode: {
    acceptByRule: 'По правилу',
    curatedOnly: 'Только вручную'
  },
  scope: {
    label: 'Область',
    global: 'Глобально',
    company: 'Компания',
    configurator: 'Конфигуратор'
  },
  addRow: 'Добавить строку',
  save: 'Сохранить',
  unsavedChanges: 'Несохранённые изменения',
  override: 'Переопределить',
  inheritedFrom: 'Унаследовано из {{origin}}',
  noRules: 'Правил пока нет',
  selectCompany: 'Выберите компанию',
  materialRulesInactiveBanner:
    'Правила материалов сейчас не влияют на виджет — материалы зон управляются через разрешённые материалы шаблона зоны (проверено 2026-08-14).',
  contextual: {
    inheritedTitle: 'Наследованные правила',
    localTitle: 'Локальные правила (этот конфигуратор)',
    levelGlobal: 'Глобальное',
    levelCompany: 'Компания',
    editOnRulesPage: 'Редактировать на странице правил',
    noInherited: 'Наследованных правил нет',
    noLocal: 'Локальных правил пока нет',
    addAttachmentRule: 'Добавить правило креплений',
    materialsPointer: 'Материалами зон управляйте в разделе',
    materialRuleInactive: 'неактивно',
    hostSocket: 'Сокет-хост',
    connector: 'Коннектор',
    connectorSelectsParts: 'Выберет детали:',
    socketRulesTitle: 'Правила этого сокета',
    socketRulesHint:
      'Какие коннекторы сюда крепятся. Правила Global и Company доступны только для чтения.',
    zoneRulesTitle: 'Правила этой зоны',
    zoneRulesHint:
      'Правила материалов, ссылающиеся на эту зону. На виджет пока не влияют.',
    allowConnector: 'Разрешить коннектор',
    levelLocal: 'Локальное',
    alreadyAllowed: 'уже разрешён',
    noSocketRules: 'Для этого сокета правил нет',
    advanced: 'Дополнительно',
    save: 'Сохранить правило',
    cancel: 'Отмена',
    close: 'Закрыть',
    remove: 'Удалить',
    preview: {
      title: 'Живое превью',
      noViewer: 'Опубликованного вьюера ещё нет — виджету не с чем сверяться',
      noTargets:
        'Этот hostPattern не накрывает ни одного сокета текущего дефолтного варианта — правило уйдёт в пустоту',
      noPartsYet: 'Сокет попадает под правило — сейчас в нём нет деталей.',
      nested: 'вложенный',
      curatedOnlyHint:
        'Кандидаты по правилам здесь не показываются, пока сокет не переключён в accept-by-rule',
      savedRefreshed:
        'Правило сохранено — ниже кандидаты после перезагрузки вьюера'
    }
  }
};
